import { render, staticRenderFns } from "./HeadingView.vue?vue&type=template&id=4748dbe7"
import script from "./HeadingView.vue?vue&type=script&lang=js"
export * from "./HeadingView.vue?vue&type=script&lang=js"
import style0 from "./HeadingView.vue?vue&type=style&index=0&id=4748dbe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports